import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export class FastPhonicsController extends Controller {
  queryParams = ['studentGrade', 'contentLevel']

  @tracked studentGrade = 'all'

  @tracked contentLevel = 'all'
}

export default FastPhonicsController

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/fast-phonics': FastPhonicsController
  }
}
